export const PLASS_SOKNAD_BASE = '/barnehageplass'
export const PLASS_TILBUD_ROUTE = PLASS_SOKNAD_BASE + '/tilbud'
export const PLASS_ENDRE_ROUTE = PLASS_SOKNAD_BASE + '/endre'

export const DINE_SØKNADER_ROUTE = '/dine-søknader'
export const DINE_SAKER_ROUTE = '/dine-saker'
export const PRIS_SØKNADER_ROUTE = '/barnehagepris'
export const AVSLUTT_PRIS_SØKNAD_ROUTE = '/barnehagepris/avsluttsoknad'
export const PRIS_SØKNAD_ROUTE = '/barnehagepris/soknad'
export const OPPSIGELSE_ROUTE = '/oppsigelse'
export const PERMISJON_ROUTE = '/permisjon'
export const PLASSERING_ROUTE = '/plassering'